<!-- 代理商信息 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <Form v-if="name_id == 1" :model="newFormData" label-position="left" :label-width="80">
                    <div class="form-title">代理 ( 经销 ) 商</div>
                    <FormItem label="名称颜色"><ColorPicker v-model="newFormData.content.title_color"/></FormItem>
                    <FormItem label="文字大小"><Input v-model="newFormData.content.title_size" placeholder="文字大小"></Input></FormItem>
                    <div class="form-title">代理商信息</div>
                    <FormItem label="信息显示">
                        <CheckboxGroup v-model="newFormData.content.type" @on-change="typeChange">
                            <Checkbox label="授权编号"></Checkbox>
                            <Checkbox label="手机号码"></Checkbox>
                            <Checkbox label="负责区域"></Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem label="内容颜色"><ColorPicker v-model="newFormData.content.text_color"/></FormItem>
                    <FormItem label="文字大小"><Input v-model="newFormData.content.size" placeholder="文字大小"></Input></FormItem>
                    <div class="form-title">背景设置</div>
                    <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                </Form>
                <Form v-if="name_id == 2" :model="newFormData" label-position="left" :label-width="80">
                    <div class="form-title">组件间距</div>
                    <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                    <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                    <div class="form-title">圆角设置</div>
                    <FormItem label="上圆角"><Slider class="w300" v-model="newFormData.content.marginData.topRadius"></Slider></FormItem>
                    <FormItem label="下圆角"><Slider class="w300" v-model="newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            name_id: "1",
        };
    },
    mounted() {
    },
    methods: {
        selectName(name) {
            this.name_id = name;
        },
        typeChange(e) {
            console.log("eee", e);
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
</style>